"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStepperLine = exports.StyledStepperNumber = exports.StyledStepperCircle = exports.StyledStepsWrapper = exports.StyledStep = exports.StyledText = exports.StyledStepperContainer = void 0;
/* eslint-disable no-nested-ternary */
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledStepperContainer = styled_components_1.default.div `
  display: flex;
  align-items: baseline;
`;
exports.StyledText = styled_components_1.default.div `
  margin-top: ${({ theme }) => theme.sizes['4xs'].value} !important;
  position: absolute;
  white-space: nowrap;

  text-align: center;

  left: 50%;
  top: 16px;
  transform: translatex(-50%);
`;
exports.StyledStep = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-self: center;
  margin: auto ${({ theme }) => theme.sizes['4xs'].value};
  position: relative;
`;
exports.StyledStepsWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-self: center;
`;
exports.StyledStepperCircle = styled_components_1.default.span `
  display: flex;
  justify-content: center;

  width: ${({ theme }) => theme.sizes.s.value};
  height: ${({ theme }) => theme.sizes.s.value};

  border: ${({ theme, active, currentStep }) => currentStep
    ? `${theme.borders['border-2px--solid']['border-style'].value} ${theme.borders['border-2px--solid']['border-width'].value} ${theme.colors.colours.default['digital-black'].value}`
    : active
        ? '0'
        : `${theme.borders['border-2px--solid']['border-style'].value} ${theme.borders['border-2px--solid']['border-width'].value} ${theme.colors.colours.support[60].value}`};
  border-radius: 50%;
  align-items: center;
  margin: auto;
  box-sizing: border-box;
`;
exports.StyledStepperNumber = styled_components_1.default.span `
  font-size: ${({ theme }) => theme.typography.desktop.text.tiny_bold['font-size'].value};
  font-weight: ${({ theme }) => theme.typography.desktop.text.tiny_bold['font-weight'].value};
  line-height: ${({ theme }) => theme.typography.desktop.text.tiny_bold['line-height'].value};
  font-family: ${({ theme }) => theme.typography.desktop.text.tiny_bold['font-family'].value};
  display: flex;
  justify-content: center;
  color: ${({ theme, active }) => active ? theme.colors.colours.default['digital-black'].value : theme.colors.colours.support[60].value};
`;
exports.StyledStepperLine = styled_components_1.default.span `
  margin-top: ${({ theme }) => theme.sizes['3xs'].value};
  display: inline-block;
  flex: 1;
  height: ${({ theme }) => theme.sizes['4xs'].value};
  background-color: ${({ theme, active }) => active ? theme.colors.colours.default['digital-black'].value : theme.colors.colours.support[60].value};
`;
//# sourceMappingURL=Stepper.styled.js.map